export default "__VITE_ASSET__c14acae8__"